<template>
  <div class="login-register">
    <notifications group="error" position="bottom right" />
    <div class="container grid-list-md text-xs-center" v-if="!isWhiteLabel">
      <div class="layout align-center justify-center row">
        <img src="../../assets/images/nextlead-dark-logo.png" class="logo item"/>
      </div>
    </div>
    <div class="login-box card shadow-sm">
      <div class="card-body">
        <form class="form-horizontal form-material" @submit.prevent="login">
          <h3 class="box-title m-b-20">Sign In</h3>

          <div class="form-group">
            <div class="col-xs-12">
              <input type="text" name="email" class="form-control" :class="{'is-invalid': errors.has('email')}" v-validate="'required|email'" v-model.trim="form.email" placeholder="Email">
              <small v-show="errors.has('email')" class="invalid-feedback">
                {{ errors.first('email') }}
              </small>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-12">
              <input type="password" name="password" class="form-control" :class="{'is-invalid': errors.has('password')}" v-validate="'required'" v-model.trim="form.password" placeholder="Password">
              <small v-show="errors.has('password')" class="invalid-feedback">
                {{ errors.first('password') }}
              </small>
            </div>
          </div>

          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Sign In</button>
            </div>
          </div>
        </form>
        <svg v-if="showSpinner" class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"></circle>
        </svg>
      </div>
    </div>
    <div class="container grid-list-md text-xs-center" v-if="!isWhiteLabel">
      <div class="layout align-center justify-center row">
        <span class="pr-2">Don't have an account?</span><router-link to="/signup"> Sign up Now</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import request from 'superagent';

export default {
  name: 'Login',
  data() {
    return {
      form: {},
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters(['isWhiteLabel']),
  },
  methods: {
    async login() {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      const email = this.form.email;
      const password = this.form.password;

      this.showSpinner = true;

      request
        .post(`${process.env.API_HOST}/login`)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({ email, password }))
        .then(data => {
          this.$store.dispatch('login', data.body);

          // go to the console
          this.$router.push({ path: '/' });
        })
        .catch(e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .logo {
    max-height: 45px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue